// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2v-0F","title":"Info_title__23psi","selects":"Info_selects__6WFMQ","requiredAsterisk":"Info_requiredAsterisk__2AF8s"};